import { render, staticRenderFns } from "./TrackingRecipientsInput.vue?vue&type=template&id=51b3edcc&scoped=true&"
import script from "./TrackingRecipientsInput.vue?vue&type=script&lang=js&"
export * from "./TrackingRecipientsInput.vue?vue&type=script&lang=js&"
import style0 from "./TrackingRecipientsInput.vue?vue&type=style&index=0&id=51b3edcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3edcc",
  null
  
)

export default component.exports